export function transformNextInstanceTemplate(data: {
  _id: any;
  tournamentId: any;
  tournamentName: any;
  prizePool: { value: any; currency: any };
  endDate: any;
}) {
  if (!data) return null;
  return {
    id: data._id || data.tournamentId,
    type: "tournament",
    tooltipText: "dailyTournamentTooltip",
    name: data.tournamentName,
    prizePool: data.prizePool.value,
    currency: data.prizePool.currency || "TRY",
    accountTicket: null,
    endDate: data.endDate,
    tournamentData: data,
  };
}

export function transformRaffleUpdateData(data: {
  account_tickets: any;
  total_prize: any;
  trigger: { points: any };
  progress: any;
}) {
  if (!data) return null;
  return {
    accountTicket: data?.account_tickets,
    prizePool: data.total_prize,
    trigger: data?.trigger?.points,
    progress: data.progress,
  };
}

export function transformRaffleData(data: {
  id: any;
  name: any;
  total_prize: any;
  currency: any;
  account_tickets: any;
  expire_time: any;
  trigger: { points: any };
  progress: any;
}) {
  if (!data) return null;
  return {
    id: data.id,
    type: "raffle",
    tooltipText: "monthlyDrawTooltip",
    name: data.name,
    prizePool: data.total_prize,
    currency: data.currency,
    accountTicket: data.account_tickets,
    endDate: data?.expire_time,
    trigger: data?.trigger?.points,
    progress: data.progress,
  };
}

export function transformGamesData(
  data: { [x: string]: { [x: string]: any } },
  ...arg: string[]
) {
  let games: any = [];
  let providers = {};
  let allProviders: any = [];
  let gameTags = {};
  let allData = {};

  for (let d of [...arg]) {
    for (let provider in data[d]) {
      if (Object.keys(allData).includes(provider)) {
        allData[provider]["products"] = [
          ...allData[provider]?.products,
          ...data[d][provider]?.products,
        ];
      } else {
        allData[provider] = data[d][provider];
      }
    }
  }

  for (let provider in allData) {
    if (
      provider.slice(provider.lastIndexOf(" ")) === " Live" ||
      provider.slice(provider.lastIndexOf(" ")) === " Virtual"
    ) {
      provider = provider
        .split("")
        .splice(0, provider.lastIndexOf(" "))
        .join("");
    }

    allProviders.push(provider);
  }

  allProviders = Array.from(new Set([...allProviders]));

  for (let provider in allData) {
    games = [
      ...games,
      ...allData[provider].products.map((g: any) => {
        return { ...g, provider: provider };
      }),
    ];
  }
  games.sort(
    (g1: { priority: number }, g2: { priority: number }) =>
      g2.priority - g1.priority
  );

  // Construct provider and tag lists based on its games' priorities
  //
  for (let game of games) {
    if (!game.gameType) {
      continue;
    }
    let category = game.gameType;

    if (!providers[category]) {
      providers[category] = ["all", game.provider];
    } else if (!providers[category].includes(game.provider)) {
      providers[category].push(game.provider);
    }

    if (!gameTags[category]) {
      gameTags[category] = ["all", ...game.tags];
    } else {
      gameTags[category] = [...gameTags[category], ...game.tags];
    }
  }

  // Keep unique tags only
  for (let category in gameTags) {
    gameTags[category] = Array.from(new Set(gameTags[category]));
  }
  // Categories
  const gameCategories = Array.from(
    new Set(games.map((g: { gameType: any }) => g.gameType))
  );

  return { providers, games, gameTags, gameCategories, allProviders };
}

export function transformForAllGameBoxData(data: {
  categories: any;
  id: any;
  prize: { type: any; amount: any; currency: any };
  name: any;
  expire_time: any;
  progress: any;
  status: any;
  trigger: { points: any };
  account_tickets: any;
  description: any;
  short_description: any;
}) {
  if (!data) return null;
  return {
    categories: data.categories,
    id: data.id,
    type: data.prize?.type || '',
    tooltipText: "",
    name: data.name,
    prizePool: data.prize?.amount,
    currency: data.prize?.currency || '',
    endDate: data.expire_time,
    progress: data.progress,
    status: data.status,
    trigger: data.trigger?.points,
    accountTicket: data.account_tickets,
    description: data.description || null,
    short_description: data.short_description || null,
  };
}

export function transformPrizePoolData(data: {
  accountTicket: any;
  tickets: string | any[];
  prizePool: { value: any; currency: any };
  total_prize: any;
  currency: any;
}) {
  if (!data) return null;
  return {
    accountTicket:
      data?.accountTicket ?? (data?.tickets && data?.tickets.length) ?? null,
    prizePool:
      data?.prizePool?.value || data?.total_prize || data?.prizePool || null,
    currency: data?.prizePool?.currency || data?.currency || "TRY",
  };
}

export function transformFreeRoundsData(data: any) {
  if (!data) return null;
  let freeroundData = data;
  if (data?.submissions) {
    let currentMission = data?.submissions?.find(
      (m: { status: string }) => m.status === "inProgress"
    );
    freeroundData = !!currentMission ? currentMission : data?.submissions?.[0];
  }
  return {
    id: freeroundData?.id,
    type: "freespins",
    tooltipText: "monthlyDrawTooltip",
    name: freeroundData?.name,
    prizePool: freeroundData?.prize?.amount,
    currency: freeroundData?.prize?.currency,
    accountTicket: freeroundData?.account_tickets,
    endDate: freeroundData?.expire_time,
    trigger: freeroundData?.trigger?.points,
    progress:
      freeroundData?.status === "completed"
        ? freeroundData?.total_points
        : freeroundData?.progress,
    status: freeroundData?.status,
    newFreespinsCount: freeroundData?.prize?.spinCount,
    gameIds: freeroundData?.prize?.gameIds?.[0],
    hasWageringPhase: freeroundData?.prize?.releaseType !== "immediately",
    isProgressive: data?.submissions?.length,
  };
}
